import styled from 'styled-components/macro';
import { BREAKPOINTS, deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { Images } from 'assets/images';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { BORDER_RADIUS } from 'utils/baseStyleSizes';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const AboutSection = styled.div``;

export const ContentContainer = styled.div`
  background-image: url(${Images.discoverBack});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  & * {
    color: ${COLORS.mainColor};
  }
`;
export const AboutWrapper = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  justify-content: center;
  padding: 50px 286px 200px;

  @media ${BREAKPOINTS.xl} {
    padding-left: 140px;
    padding-top: 32px;
    padding-right: 142px;
  }

  @media ${BREAKPOINTS.lg} {
    padding-left: 60px;
    padding-top: 20px;
    padding-right: 100px;
  }

  @media ${BREAKPOINTS.md} {
    padding-left: 40px;
    padding-top: 14px;
    padding-right: 40px;
  }
`;
export const AboutfirstItemWrapper = styled.div`
  ${FLEX_CONTAINER.FlexStartRow}
  width: 100%;
  align-items: unset;
  min-height: 480px;
  @media ${BREAKPOINTS.lg} {
    ${FLEX_CONTAINER.FlexCenterColumn};
    flex-direction: column-reverse;
  } ;
`;

export const DiscoweImg = styled.img`
  width: 100%;
  height: 330px;
  border-radius: ${BORDER_RADIUS.radius8};

  @media ${BREAKPOINTS.lg} {
    width: 100%;
    height: 430px;
    padding-top: 50px;
  }

  @media ${BREAKPOINTS.md} {
    width: 100%;
    height: 280px;
  }

  @media ${BREAKPOINTS.sm} {
    width: 100%;
    height: 220px;
  }
`;

export const DiscoverWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-left: 125px;

  @media ${BREAKPOINTS.lg} {
    margin-left: 0;
  }
`;

export const SectionTitle = styled.p`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
  color: ${COLORS.blueBlack};
  margin-bottom: 10px;
  min-width: max-content;

  @media ${BREAKPOINTS.lg} {
    margin-bottom: 14px;
    ${FONTS.font20}
  }

  @media ${BREAKPOINTS.md} {
    margin-bottom: 14px;
    ${FONTS.font16}
    margin-left:0;
  }

  @media ${BREAKPOINTS.sm} {
    ${FONTS.font14}
    margin-bottom: 12px;
  }
`;

export const Section = styled.section`
  @media ${deviceMin.mobileS} {
    height: 1000px;
  }

  @media ${deviceMin.mobileM} {
    height: 900px;
  }

  @media ${deviceMin.desktop} {
    height: 1468px;
  }
`;

export const ButtonConainer = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  min-width: max-contnet;
  height: 30px;
`;

export const Button = styled.div`
  cursor: pointer;
  width: max-content;
  &:nth-child(2) {
    margin-left: 70px;
  }
  &:nth-child(3) {
    margin-left: 70px;
  }
  border-bottom: ${({ section, type }) =>
    section === type ? `2px solid ${COLORS.mainColor}` : ''};
  @media ${BREAKPOINTS.md} {
    ${FONTS.font16}

    &:nth-child(2) {
      margin-left: 30px;
    }
    &:nth-child(3) {
      margin-left: 30px;
    }
  }
  @media ${BREAKPOINTS.sm} {
    ${FONTS.font14}
  }

  &:hover {
    border-bottom: 2px solid ${COLORS.mainColor};
  }
`;

export const AboutSectionReadMoreButtonContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  cursor: pointer;
`;

export const ReadMoreButton = styled.button`
  ${FONTS.font14}
  color: ${COLORS.blueBlack};

  :hover {
    color: ${COLORS.mainColor_op7};
  }

  @media ${deviceMin.mobileS} {
    ${FONTS.font14};
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font16};
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font16};
  }
`;

export const ReadMoreButtonIcon = styled.img`
  width: 18px;
  height: 8px;
  margin-left: 5px;
`;

export const TravelIcon = styled.img`
  width: 204px;
  height: 160px;
  position: absolute;
  right: 0;
  top: 350px;

  @media ${BREAKPOINTS.xl} {
    width: 204px;
    height: 160px;
  }
  @media ${BREAKPOINTS.lg} {
    display: none;
  }
`;

export const AboutSectionSubTitle = styled.p`
  padding-top: 22px;
  ${FONTS.font16};
  color: ${COLORS.blueBlack};
  width: 100%;
  padding-right: 40px;
  @media ${BREAKPOINTS.xl} {
    ${FONTS.font16}
  }

  @media ${BREAKPOINTS.sm} {
    ${FONTS.font14}
  }
`;

export const SecondSection = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 100%;
  margin-top: 50px;

  @media ${BREAKPOINTS.lg} {
    ${FLEX_CONTAINER.FlexColumn}
    align-items:unset;
  }
`;

export const SecondSectionInfo = styled.div`
  height: auto;
`;

export const DiscoverBackSecondImage = styled.img`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  width: 450px;
  height: 330px;
  border-radius: 8px;
  object-fit: cover;
  margin-top: 20px;

  @media screen and ${BREAKPOINTS.xl} {
    width: 100%;
    height: 330px;
  }

  @media screen and ${BREAKPOINTS.lg} {
    height: 430px;
  }

  @media ${BREAKPOINTS.md} {
    width: 100%;
    height: 200px;
  }
`;
